import React from "react"
import PropTypes from "prop-types"
import Radium from "higher-order-components/configured-radium/"

/**
 * Render an image component
 * @param { imageSrc } Src of Image
 * @param { imageAlt } Alt of Img element
 * @returns {ReactElement} React Component
 */
const ImageBlock = ({ imageSrc, imageAlt }) => <img data-test="image-block" src={imageSrc} alt={imageAlt} style={{ width: "100%" }} />

export default Radium(ImageBlock)

ImageBlock.propTypes = {
  imageSrc: PropTypes.string,
  imageAlt: PropTypes.string
}



// WEBPACK FOOTER //
// ./src/containers/image-block/index.jsx